import { getSeverityColour } from "core/utils/severityTypes";

/**
 * Gets what type of rule level (fleet, site or machine), based on if site and machine id are defined
 * @param siteId the site of the rule level
 * @param machineId the machine of the rule level
 * @returns {string} "Fleet", "Site" or "Machine"
 */
export const getThresholdTypeName = (siteId, machineId) => {
  if (siteId) {
    if (machineId) {
      return "Machine";
    }

    return "Site";
  }

  return "Fleet";
};

/**
 * Converts the rule levels into series for the chart
 * @param ruleLevels the rule levels to convert into series
 * @param severityTypes a list of the available level types
 * @param dateTimes all the dateTimes that exist on the graph
 * @param yUnit the unit to display in the tooltip
 * @returns {*} a list of series
 */
export const getSeriesFromRuleLevels = (
  ruleLevels,
  severityTypes,
  dateTimes,
  yUnit = ""
) => {
  return ruleLevels.map(ruleLevel => {
    const severityType = severityTypes.find(
      x => x.id === ruleLevel.rule_level_type_id
    );
    let thresholdColour = getSeverityColour(severityType.colour);

    const thresholdTypeName = getThresholdTypeName(
      ruleLevel.site_id,
      ruleLevel.machine_id
    );

    const thresholdName = `${severityType.name ?? ""}: ${thresholdTypeName}`;

    return {
      name: thresholdName,
      type: "line",
      data: dateTimes.map(dateTime => [dateTime, ruleLevel.level]),
      color: thresholdColour,
      zIndex: 0,
      showInLegend: true,
      label: {
        text: thresholdName,
        style: {
          color: thresholdColour
        },
        align: "left"
      },
      tooltip: {
        valueSuffix: yUnit
      },
      marker: {
        enabled: false
      }
    };
  });
};
